// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB7mxWKkBlDy24ZOCEKcQHix_Nc9Jn9WKo",
  authDomain: "document-readers.firebaseapp.com",
  projectId: "document-readers",
  storageBucket: "document-readers.appspot.com",
  messagingSenderId: "421423473510",
  appId: "1:421423473510:web:7d09af8b25d39315a3dea7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

